import { createStore } from "vuex";
import VuexPersistence from 'vuex-persist';
import { auth } from "./auth.module";
import { app } from "./app.module";

const vuexPlugins = []

if (process.env.NODE_ENV === 'development') {
    const vuexLocal = new VuexPersistence({
        key: 'com-studio-state',
        storage: localStorage
    });
    vuexPlugins.push(vuexLocal.plugin)
}

const store = createStore({
    modules: {
        auth, app
    },
    plugins: vuexPlugins
});

export default store;
